<kl-grid
    #gridComponent
    [columns]="[{ header: 'customer_description' | translate, binding: 'company_title', width: '*', visible: true }, { header: 'customer_address' | translate, binding: 'address', width: '*', visible: true }, { header: 'tax_num' | translate, binding: 'tax_nr', width: '*', translate: true, visible: true }, { header: 'tax_office' | translate, binding: 'tax_office', width: '*', translate: true, visible: true }, { header: 'logo_main_package_license' | translate, binding: 'logo_product_key', width: '*', translate: true, visible: true }]"
    [filterable]="true"
    [deferResizing]="true"
    [tabId]="tabId || modalId"
    [service]="{
     service: 'license-package/license-control',
    name: 'lem_info',
    form: 'LEM_INFO_FORM',
    showButton: true,
    showDropDownButton: true,
    editByCustomField:true,
    customFieldName:'product-key',
    customEndpoint: 'product-key'
  }"
    [parentModuleName]="'APPLICATION_PARAMS'"
    [moduleName]="'LEM_INFO_LIST'"
    [gridName]="'grdLemInfoList'"
    [customFilter]="true"
    [filterSelectItems]="filterSelectItems"
    [filterObject]="filterObject"
    [doAdd]="false"
    [dblSelect]="true"
    (onDblClickCall)="onSelect($event)"
>
</kl-grid>
